import apiClient from './apiClient';
import { RosePack, RoseTransaction } from '../../types';

const rosesApi = {
  getBalance: () =>
    apiClient.get('/roses/balance').then((r) => r.data),

  getPacks: () =>
    apiClient.get('/roses/packs').then((r) => r.data),

  getHistory: (cursor?: string) =>
    apiClient.get('/roses/history', { params: { cursor } }).then((r) => r.data),

  getReceived: () =>
    apiClient.get('/roses/received').then((r) => r.data),

  sendRose: (toUserId: string) =>
    apiClient.post(`/roses/send/${toUserId}`).then((r) => r.data),

  purchasePack: (pack: RosePack, paymentProvider: 'ozow' | 'paystack') =>
    apiClient.post('/roses/purchase', { ...pack, paymentProvider }).then((r) => r.data),

  getPurchaseStatus: (reference: string) =>
    apiClient.get(`/roses/purchase-status/${encodeURIComponent(reference)}`).then((r) => r.data),
};

export type { RosePack, RoseTransaction };
export default rosesApi;
